import React, { useContext } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";

import QuestionnaireStatistics from "../../../templates/teacher/QuestionnaireStatistics";
import {
  Context,
  fetchSurveyAnswers,
  notFoundPath,
} from "../../../teacherStore";
import { IStudent, IClass } from "../../../state";

export default () => {
  const { state, dispatch } = useContext(Context);
  const { teaching_material_id, student_id } = useParams();
  const history = useHistory();
  const location = useLocation<{ student: IStudent; currentClass: IClass }>();

  if (!location.state) {
    history.push(notFoundPath);
    return null;
  }

  React.useEffect(() => {
    dispatch(
      fetchSurveyAnswers(Number(teaching_material_id), Number(student_id)),
    );
  }, [dispatch, student_id, teaching_material_id]);

  return (
    <QuestionnaireStatistics
      student={location.state.student}
      class_name={location.state.currentClass.full_name}
      survey_answers={state.survey_answers}
      survey_answers_per_teaching_material={
        state.survey_answers_per_teaching_material
      }
    />
  );
};
